export const urlReplacer = ({ url, removePort = false }) => {
  const unwantedStrings = ['www.', 'beta.', 'internal.', 'local.', 'beta-'];
  let trimmed = url;
  if (removePort && window.location.port) {
    trimmed = trimmed.replace(`:${window.location.port}`, '');
  }
  unwantedStrings.forEach(unwantedString => {
    trimmed = trimmed.replace(unwantedString, '');
  });
  return trimmed;
};

export const isExternalVerticalActive = (url = '') => {
  const currentUrl = urlReplacer({ url: window.location.origin, removePort: true });

  return currentUrl.startsWith(urlReplacer({ url }));
};
